export default __webpack_public_path__ + "locales/pt-BR/DowngradePlanDialog.json?hash=c08146d1f186f695920b1c0f918dc478";